<template>
  <div>
    <!-- 产品推荐 -->
    <div class="PRODUCT">
      <div class="mainCard">
        <div class="nameItem">
          <h1>环境监测平台</h1>
          <h2>ENVIRONMENTAL MONITORING PLATFORM</h2>
        </div>
        <n-card
          class="cardItem"
          v-for="(item, index) in recommended"
          :key="index"
        >
          <template #cover>
            <n-image width="100" :src="item.img" />
          </template>
          <div class="text" @click="toMsg(index)">
            {{ item.name }}
          </div>
        </n-card>
      </div>
      <div class="mainCard" style="margin-top: 50px;">
        <div class="nameItem">
          <h1>产品推荐</h1>
          <h2>PRODUCT RECOMMENDATION</h2>
        </div>
        <n-card
          class="cardItem"
          v-for="(item, index) in recommended2"
          :key="index"
        >
          <template #cover>
            <n-image width="100" :src="item.img + item.name + '.png'" />
          </template>
          <div class="text" @click="equMsg(item)">
            {{ item.name }}
          </div>
        </n-card>
      </div>
    </div>

    <div>
      <div class="nameItem">
        <h1 id="isUS">关于我们</h1>
        <h2>ABOUT US</h2>
      </div>
      <!-- <img
        class="carousel-img"
        src="https://naive-ui.oss-cn-beijing.aliyuncs.com/carousel-img/carousel1.jpeg"
      /> -->
      <p class="usText">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        河南宸华环保科技有限公司创建于2019年，隶属于中环汇科(北京)生态环境技术研究院有限公司。是一家值得信赖的创新性科技公司，致力于创造安全、环保、健康、智慧、的工作生活环境。
        公司围绕物联网产业，将感知传感器、智能终端、通讯技术、云计算和地理信息等物联网技术紧密结合，建立完整的物联网产业链，结合环保治理、节能技术，以客户价值为导向，为智慧城市、安全生产、环境保护、民生健康提供完善的解决方案。宸华环保科技还致力于机动车尾气遥感监测，水质、烟气在线监测等环境监测解决方案，运维服务，环境检测服务；我们也擅长煤矿综采设备维修、煤矿井下装修、矿用设备、环保设备、实验室设备、家具，实验室装修，实验室整体搬迁等业务。同时也是一家第三方委托机构,主要运营烟气、烟尘、水、VOC、土壤治理,空气站和其他方面在线监测服务及数据库维护的公司。宸华环保多年以来秉承“信誉，诚信为本”的经营理念,得到了普遍认可。
      </p>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import router from "@/router";

// 新闻中心、解决方案页面数据
const home = {
  news: [
    {
      title: "乡村建设行动路线图明确!",
      date: "2023-03-12",
      text: "中共中央办公厅、国务院办公厅近日印发《乡村建设行动实施方案》（以下简称《方案》），为扎实推进乡村建设行动，进一步提升乡村宜居宜业水平指明了路径和方向。《方案》提出，到2025年，乡村建设要取得实质性进展，农村人居环境持续改善，农村公共基础设施往村覆盖、往户延伸取得积极进展，农村基本公共服务水平稳步提升，农村精神文明建设显著加强，农民获得感、幸福感、安全感进一步增强。围绕相关目标，《方案》部署了多项重点工作。其中包括，实施农村人居环境整治提升五年行动，推进农村厕所。因地制宜选择改厕技术模式，合理规划布局公共厕所，稳步提高卫生厕所普及率。统筹农村改厕和生活污水、黑臭水体治理，因地制宜建设污水处理设施，基本消除较大面积的农村黑臭水体。健全农村生活垃圾收运处置体系，完善县乡村三级设施和服务，推动农村生活垃圾分类减量与资源化处理利用。因地制宜开展荒山荒地荒滩绿化，引导鼓励农民开展庭院和村庄绿化美化，建设村庄小微公园和公共绿地。",
    },
    {
      title: "环境监测的含义",
      date: "2023-01-12",
      text: "监督性监测又称为例行监测或常规监测，是对指定的有关项目进行定期的、长期的监测，以确定环境质量及污染源状况、评价控制措施的效果，衡量环境规范实施状况和环境保护作业的进展。这是监测作业中量大、面广的作业。监督性监测包括环境质量监测和污染源的监督监测。",
    },
  ],
  plan: [
    {
      title: "机动车环境管理解决方案",
      date: "2023-01-12",
      text: "机动车污染防治是一项系统工程，应加强“车、油、路”统筹，采取法律、行政、经济、技术等综合措施进行防治，强化信息公开，形成政府主导、部门协作、市场调节、社会监督的工作机制",
    },
    {
      title: "道路空气质量解决方案",
      date: "2023-01-12",
      text: "路交通空气质量监测系统是以监测道路机动车排放污染物特征为目的，部署于污染较重城市和污染物传输通道。",
    },
  ],
};

localStorage.setItem("data", JSON.stringify(home));
localStorage.setItem(
  "dataMessage",
  JSON.stringify(require("../components/data.json"))
);
const recommended = [
  {
    name: "能耗在线监测系统",
    img: "http://chenhuakeji.cn/image/systemImg/1.png",
    text: "能耗在线监测系统是一种用于实时监测和管理能耗的系统。它能够帮助用户追踪能源使用情况，发现能源浪费和效率低下的问题，并提供相应的解决方案。",
  },
  {
    img: "http://chenhuakeji.cn/image/systemImg/2.png",
    name: "机动车尾气遥感监测系统",
    text: "机动车尾气遥感监测系统是一种利用遥感技术实时监测动力车辆尾气排放的系统。该系统旨在提供高效、准确的动车尾气监测方案，以帮助交通管理部门实施尾气排放监管和环境保护。",
  },
  {
    img: "http://chenhuakeji.cn/image/systemImg/3.png",
    name: "机动车黑烟智能抓拍系统",
    text: "机动车黑烟智能抓拍系统是一种利用智能技术实时监测和抓拍机动车辆尾气黑烟排放的系统。提供高效、准确的黑烟排放监测方案，以帮助城市环保管理部门实施尾气排放监管和治理。",
  },
  {
    img: "http://chenhuakeji.cn/image/systemImg/4.png",
    name: "油烟在线监测系统",
    text: "油烟在线监测系统是一种用于实时监测油烟排放的系统。提供有效的油烟监测方案，以监测和评估烹饪场所、工业生产等环境中的油烟排放情况，并支持环境保护和健康管理的决策制定。",
  },
  {
    img: "http://chenhuakeji.cn/image/systemImg/5.png",
    name: "VOCs走航监测分析系统",
    text: "VOCs走航监测分析系统是一种用于实时监测和分析挥发性有机化合物（VOCs）浓度的系统。它通过进行走航采样和实时分析，帮助用户了解环境中VOCs的分布情况，监测污染源和评估空气质量。",
  },
  {
    img: "http://chenhuakeji.cn/image/systemImg/6.png",
    name: "大气颗粒物组分分析系统",
    text: "大气颗粒物组分分析系统旨在实时监测和分析大气中的颗粒物组分，以评估空气质量和环境污染状况。",
  },
];
const recommended2 = [
  {
    name: "固定水平式机动车尾气遥感监测系统",
    text: "图片仅供参考，详情请联系咨询：400-1599-006",
    message: "暂无",
    img: "http://chenhuakeji.cn/image/product/",
  },
  {
    name: "固定垂直式机动车尾气遥感监测系统",
    text: "图片仅供参考，详情请联系咨询：400-1599-006",
    message: "暂无",
    img: "http://chenhuakeji.cn/image/product/",
  },
  {
    name: "移动式机动车尾气遥感监测系统",
    text: "图片仅供参考，详情请联系咨询：400-1599-006",
    message: "暂无",
    img: "http://chenhuakeji.cn/image/product/",
  },
  {
    name: "车载式柴油车OBD远程在线监控系统",
    text: "图片仅供参考，详情请联系咨询：400-1599-006",
    message: "暂无",
    img: "http://chenhuakeji.cn/image/product/",
  },
  {
    name: "黑烟车电子抓拍识别系统",
    text: "图片仅供参考，详情请联系咨询：400-1599-006",
    message: "暂无",
    img: "http://chenhuakeji.cn/image/product/",
  },
  {
    name: "VOCs走航监测设备",
    text: "图片仅供参考，详情请联系咨询：400-1599-006",
    message: "暂无",
    img: "http://chenhuakeji.cn/image/product/",
  }
]
const toMsg = (index) => {
  router.push({
    path: "Message",
    query: {
      index: index,
    },
  });
};
const equMsg = (data) => {
  localStorage.setItem("product", JSON.stringify(data));
  router.push({
    path: "MessageInfo",
  });
};
</script>
<style scoped>
.cardItem {
  cursor: pointer;
}
.text {
  line-height: 6vh;
  font-size: 19px;
  font-weight: bold;
  overflow: hidden;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.carousel-img {
  width: 100%;
  height: 65vh;
}

.n-card {
  max-width: 18%;
  display: inline-block;
  margin: 2vh 4vw 8vh 4vw;
}
.mainCard {
  width: 96vw;
  margin: 0 auto;
  background: white;
  padding: 30px 10px 30px 10px;
  -moz-box-shadow: 0px 0px 10px #e9e9e9;
  -webkit-box-shadow: 0px 0px 10px #d3d3d3;
  box-shadow: 0px 0px 10px #d3d3d3;
}
.PRODUCT {
  background: #f1f3f5;
  padding: 3vh 0 3vh 0;
  margin-bottom: 7vh;
}
.nameItem {
  margin-bottom: 7vh;
}
.usText {
  width: 70vw;
  margin: 0 auto;
  line-height: 5vh;
  padding-top: 2vh;
  font-size: 17px;
}
</style>